import { Injectable } from '@angular/core';
import { Router } from '@angular/router'; 
import { FeedbackModel } from 'common/models/page-models/feedback/feedback-data-model';
import { FeedbackListingModel } from 'common/models/page-models/feedback/feedback-grid-model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { FeedbackGridWidgetService } from 'common/widget/feedback/feedback-grid-widget';
 
@Injectable({
    providedIn: 'root'
})
export class FeedbackGridResolver extends GridResolver<FeedbackModel, FeedbackListingModel> {
    constructor(
        protected fs: FeedbackGridWidgetService,
        protected override  router: Router,
        protected override  systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}